import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { checkOptionThunk } from '@/store/option/thunks/checkOptionThunk.ts';
import { duplicateTile } from '@/store/tiles/slice.ts';

export const registerDuplicateOptionTradeCaptureListener = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: duplicateTile,
    effect: async (action, api) => {
      const { newTileId } = action.payload;

      api.dispatch(checkOptionThunk({ type: 'init', tileId: newTileId, shouldApplyUserPrefs: false }));
    },
  });
};
